import { useMutation, UseMutationResult, useQueryClient } from "@tanstack/react-query";
import { enum_api_uri } from "../utils/enum";
import axiosInstance from "./axiosInstanse";

interface addressRequest {
  addrChk: string;
}

export interface addressResponse {
    statusCode: number;
    message: string;
}

export const usePutDefaultAddress = (
    successCallback?: (data: addressResponse) => void,
): UseMutationResult<addressResponse, Error, addressRequest, unknown> => {
    const queryClient = useQueryClient();

    return useMutation<addressResponse, Error, addressRequest>({
        mutationFn: async (addressData: addressRequest) => {
            const response = await axiosInstance.put(enum_api_uri.put_default_address, addressData);
            return response.data;
        },
        onSuccess: data => {
            queryClient.invalidateQueries({ queryKey: ["useGetMypageInfo"] });
            successCallback?.(data);
        },
    });
};
